import Graphene, { type Dimensions } from "@snapchat/graphene";

interface NetworkMetricDimensions extends Dimensions {
    label: string;
    statusCode: string;
}

interface MetricsArgs {
    dimensions: NetworkMetricDimensions;
}

export class NetworkMetric {
    private startTime = -1;

    constructor(
        private readonly metricsName: string,
        private readonly ignoreReporting: boolean,
    ) {}

    startTimer(): void {
        this.startTime = performance.now();
    }

    reportMetric(args: MetricsArgs): void {
        const { dimensions } = args;

        if (this.ignoreReporting) {
            console.info("[REPORT_METRIC]", { metricsName: this.metricsName, dimensions });
        } else {
            Graphene.increment({ metricsName: this.metricsName, dimensions });
        }
    }

    reportLatency(args: MetricsArgs): void {
        if (this.startTime === -1) {
            throw new Error("Network Metric reported without being started.");
        }

        const { dimensions } = args;
        const milliSec = Math.round(performance.now() - this.startTime);

        if (this.ignoreReporting) {
            console.info("[REPORT_LATENCY]", { metricsName: this.metricsName, dimensions, milliSec });
        } else {
            Graphene.addTimer({ metricsName: this.metricsName, dimensions, milliSec });
        }
    }
}
